<div class="iframeContainer">
    <iframe #offerteiframe data-testid="offerteiframe" [src]='currentURL' height="{{height}}" title="testFrame" ></iframe>
</div>




// WEBPACK FOOTER //
// ./src/app/views/test/test_iframe.html